import React from 'react'

const PageNotFound = () => {
  return (
    <h1 style={{color:"red"}}>PageNotFound</h1>
  )
}

export default PageNotFound